import React, { useEffect } from "react";
import { DataGrid, deDE, GridColDef, GridRowParams, GridSortModel, LocalizationV4 } from "@material-ui/data-grid";
//import Tooltip from '@material-ui/core/Tooltip';
import Grid from "@material-ui/core/Grid";
import {
  Button,
  Container,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  CircularProgress
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  getSpannungswandlerR,
  selectSpannungswandlerListe,
  selectEditEntry,
  selectNewEntry,
  selectAktuellesSpannungswandler,
  selectViewMode,
  selectEditDirty,
  setEditEntry,
  updateAktuellesSpannungswandler,
  createSpannungswandler,
  updateSpannungswandler,
  setFaktor,
  setKommentar,
  discardNew,
  discardChanges,
  startNewEntry,
  deleteSpannungswandler,
  setError,
  resetError,
  selectError,
  spannungswandlerDummy,
  selectListLoading,
  selectSorting,
  setSorting,
  resetViewMode
} from "./spannungswandlerSlice";

import { useStyles } from "./../wertelisteStyles";
import { useMsal } from "@azure/msal-react";
import { spannungswandler } from "../../../../utils/apiTypes";
import { rollen, isAuthorized } from "../../../../utils/auth/authConfig";
import { validate, validateHelper } from "../../../../features/validate/validate";
import { globalStyles } from "../../../../assets/globalStyles";


export const Spannungswandler: React.FC = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const rollenObj = rollen;

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  useEffect(() => {
    dispatch(getSpannungswandlerR())
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const
    spannungswandlerSelectListe: spannungswandler[] = useAppSelector(selectSpannungswandlerListe),
    editEntry: boolean = useAppSelector(selectEditEntry),
    newEntry: boolean = useAppSelector(selectNewEntry),
    aktuelleSpannungswandler: spannungswandler = useAppSelector(selectAktuellesSpannungswandler),
    viewMode: boolean = useAppSelector(selectViewMode),
    dirtyEdit: number = useAppSelector(selectEditDirty),
    inputError: boolean = useAppSelector(selectError),
    listLoading: boolean = useAppSelector(selectListLoading),
    sorting: GridSortModel = useAppSelector(selectSorting);

  const dataGridCols2: GridColDef[] = [
    { field: 'faktor', headerName: 'Faktor', flex: 2 },
  ]

  function printTableSpannungswandler(data: spannungswandler[]) {
    return (
      <Container maxWidth={false} className={classes.root}>
        <div style={{ height: "50vh", width: '100%' }}>
          <DataGrid
            localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
            disableColumnMenu={false}
            disableColumnSelector={true}
            columns={dataGridCols2}
            getRowId={(row) => row.faktor}
            rows={data}
            sortModel={sorting}
            onSortModelChange={(model) => setSorting(model.sortModel)}
            onRowClick={(param: GridRowParams) => {
              let ws = spannungswandlerDummy;
              const currentWs = data.find(w => w.faktor == (param.row.faktor))
              if (currentWs)
                ws = currentWs;
              if (!editEntry) dispatch(updateAktuellesSpannungswandler(ws));
            }}
            loading={listLoading} />
        </div>
      </Container>
    );
  }

  function printSaveDiscardButtons() {
    return (<div>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(createSpannungswandler(aktuelleSpannungswandler)) : dispatch(updateSpannungswandler(aktuelleSpannungswandler)) }}
        color="secondary"
        className={classes.showtriButton}
        disabled={
          aktuelleSpannungswandler.faktor == ""
          || !dirtyEdit
          || inputError}
        style={{ minHeight: "36px" }}
      >
        {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
      </Button>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
        color="secondary"
        className={classes.showtriButton}
      >
        Abbrechen
      </Button>
    </div>)
  }
  function confirmDeleteOfRoutergeraet() {
    dispatch(deleteSpannungswandler(aktuelleSpannungswandler));
    setOpenDeleteDialog(false);
  }

  function printEditDeleteButton() {
    if (isAuthorized([rollenObj.admin, rollenObj.betrieb]))
      return (
        <div>
          <Button
            variant="contained"
            onClick={() => dispatch(setEditEntry())}
            color="secondary"
            className={classes.showtriButton}
          >
            Bearbeiten
          </Button>
          {!aktuelleSpannungswandler.zugeordnet ?
            <Button
              variant="contained"
              onClick={() => setOpenDeleteDialog(true)}
              color="secondary"
              className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
            >
              Löschen
            </Button> : ""}
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>Routerstelle löschen</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {'Sind Sie sicher, dass Sie das Spannungswandler "' +
                  aktuelleSpannungswandler.faktor +
                  '" wirklich löschen wollen?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenDeleteDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                variant="contained"
                onClick={confirmDeleteOfRoutergeraet}
                className={classes.confirmDeleteButton}
                style={{ minWidth: "120px", minHeight: "36px" }}
              >
                {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
              </Button>
            </DialogActions>
          </Dialog>
          <Button
            variant="contained"
            onClick={() => { dispatch(resetViewMode()) }}
            color="default"
            className={classes.showtriButton}
          >
            Schließen
          </Button>
        </div>
      );
    else return (<React.Fragment />)
  }

  function printEdit() {
    return (
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }}>
        <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
          <div>
            <Grid container spacing={4} >
              <Grid item container xs={12}>
                <Grid item md={3}>
                  <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                    {newEntry ? "Neuen Spannungswandler anlegen" : "Bearbeiten von Spannungswandler: " + aktuelleSpannungswandler.faktor.toString()}
                  </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6} >
                  {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id="spannungswandler-faktor"
                    disabled={newEntry ? false : true}
                    label="Faktor"
                    error={validate(dispatch, setError, resetError, aktuelleSpannungswandler.faktor.toString(), "faktor")}
                    helperText={validateHelper(aktuelleSpannungswandler.faktor)}
                    variant="outlined"
                    onChange={(event) => dispatch(setFaktor(event.target.value))}
                    value={aktuelleSpannungswandler.faktor}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    disabled={editEntry ? false : true}
                    id="spannungswandler-kommentar"
                    multiline
                    rows={4}
                    rowsMax={8}
                    label="Kommentar"
                    error={validate(dispatch, setError, resetError, aktuelleSpannungswandler.kommentar, "kommentar")}
                    helperText={validateHelper(aktuelleSpannungswandler.kommentar)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                    value={aktuelleSpannungswandler.kommentar ? aktuelleSpannungswandler.kommentar : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    )
  }

  return (
    <div>
      {viewMode ? printEdit() : ""}
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid item md={3} >
            <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
              Spannungswandler Übersicht
            </Typography>
          </Grid>
          <Grid item md={3} />
          <Grid item md={6} style={{ paddingRight: "24px", paddingTop: "0px" }}>
            <Grid item container md={12}>
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3}>
                {isAuthorized([rollenObj.admin, rollenObj.betrieb]) ?
                  <Button
                    variant="contained"
                    onClick={() => dispatch(startNewEntry())}
                    color="secondary"
                    className={classes.showButton}
                    disabled={editEntry ? true : false}
                  >
                    Hinzufügen
                  </Button>
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          {printTableSpannungswandler(spannungswandlerSelectListe)}
        </Grid>
      </Paper>
    </div>
  );
}
